import * as React from 'react'
import { StyleSheet, Text, View, ViewStyle } from 'react-native'
import { SolitoImage } from 'solito/image'
import { Link } from 'solito/link'
import { Spacer } from '@components/Spacer'
import { YellowCheck } from '@components/YellowCheck'
import * as Colors from '@themes/Colors'
import Fonts from '@themes/Fonts'
import { defaultShadow } from '@themes/Shadows'

const BASE_SIZE = 44

type Props = {
  id: number
  name: string
  subText?: string
  imageUrl?: string
  showCheck?: boolean
  route?: { routeName: string; params?: Record<string, string | number> }
  href: string
  containerStyles?: ViewStyle
  rightElement?: React.ReactNode
}

export function SmCardView(props: Props) {
  const [imageIsLoaded, setImageIsLoaded] = React.useState(false)
  return (
    <Link href={props.href}>
      <View style={styles.container}>
        <View style={styles.innerContainer}>
          {props.imageUrl && (
            <View style={styles.imageWrapper}>
              <SolitoImage
                src={props.imageUrl}
                onLoadingComplete={() => setImageIsLoaded(true)}
                style={{
                  opacity: imageIsLoaded ? 1 : 0,
                  backgroundColor: '#eee',
                }}
                quality={90}
                loading="lazy"
                width={BASE_SIZE}
                height={BASE_SIZE}
                contentFit="cover"
                alt={`${props.name} image`}
              />
            </View>
          )}
          <View style={styles.stackedText}>
            {props.showCheck ? (
              <View style={styles.row}>
                <Text style={styles.text} numberOfLines={1}>
                  {props.name}
                </Text>
                <Spacer noShrink width={4} />
                <YellowCheck />
              </View>
            ) : (
              <Text style={styles.text} numberOfLines={1}>
                {props.name}
              </Text>
            )}

            {props.subText ? (
              <Text style={styles.needCount} numberOfLines={1}>
                {props.subText}
              </Text>
            ) : null}
          </View>
          {props.rightElement && (
            <View style={styles.rightElement}>{props.rightElement}</View>
          )}
        </View>
      </View>
    </Link>
  )
}

const styles = StyleSheet.create({
  container: {
    flexGrow: 0,
    flexShrink: 0,
    userSelect: 'none',
    backgroundColor: Colors.white,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: Colors.borderGray,
  },
  innerContainer: {
    flexGrow: 0,
    flexShrink: 0,
    paddingHorizontal: 12,
    paddingTop: 12,
    paddingBottom: 12,
    flexDirection: 'row',
    alignItems: 'center',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  imageWrapper: {
    width: BASE_SIZE,
    height: BASE_SIZE,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: Colors.athensGray,
    borderWidth: 2,
    borderColor: '#e9eaee',
    borderRadius: BASE_SIZE / 2,
    borderStyle: 'solid',
    boxSizing: 'border-box',
    overflow: 'hidden',
  },
  row: {
    flexDirection: 'row',
    alignItems: 'flex-end',
    justifyContent: 'flex-start',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  },
  stackedText: {
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: 0,
    flexDirection: 'column',
    marginLeft: 8,
  },
  text: {
    overflow: 'hidden',
    fontFamily: Fonts.type.bold,
    fontWeight: 'bold',
    fontSize: 15,
  },
  needCount: {
    fontSize: Fonts.size.medium,
    lineHeight: Fonts.size.medium * 1.2,
    color: Colors.textGray,
    marginBottom: 3,
  },
  rightElement: {
    marginLeft: 'auto',
    paddingLeft: 12,
  },
})
